<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="ps-4 pe-4">
    <label class="lbl_name" style="border-bottom:1px solid cyan; width: 100%;">Choose payment gateway</label>
    <p-dropdown [options]="allowedPaymentProcessors" [(ngModel)]="selectedPaymentProcessor"
        (onChange)="choosedPaymentProcessor()" optionLabel="processorName" optionValue="processorName" #item="ngModel"
        [showClear]="false" placeholder="Select ..."></p-dropdown>
</div>
<div *ngIf="selectedPaymentProcessor == 'Stripe' " class="ps-4 pe-4">
    <!-- <div  class="ps-4 pe-4"> -->
    <!-- <label class="lbl_name" style="border-bottom:1px solid cyan; width: 100%;">{{'PAYMENT.CARD_INFORMATION'|translate}}
        <i *ngIf="error!=null" class="pi pi-exclamation-circle float-end me-1 error_color" pTooltip="{{error}}"
            tooltipPosition="top"></i>
    </label>
    <div class="p-2" style="border-bottom: 1px solid #808080;">
        <ngx-stripe-card [options]="cardOptions" [elementsOptions]="elementsOptions"></ngx-stripe-card>
    </div> -->
    <!-- <button class="btn_in_color" style="width:60%;" type="submit" (click)="payWithStripe(monthly)">
            {{'PAYMENT.MONTH'|translate}} {{membershipPlan.defaultMonthlyPrice | number}} {{currencyInfo.currencyCode}}
        </button>
        <button class="btn_in_color mt-3" style="width:60%;" type="submit" (click)="payWithStripe(yearly)">
            {{'PAYMENT.YEAR'|translate}} {{membershipPlan.defaultYearlyPrice | number}} {{currencyInfo.currencyCode}}
        </button> -->
    <label class="lbl_name" style="border-bottom:1px solid cyan; width: 100%;">{{'PAYMENT.ONE_TIME'|translate}}</label>
    <div class="p-field-radiobutton d-flex p-2 m-2">
        <p-radioButton name="basis" value="1" (onClick)="changeStatus(basis)" [(ngModel)]="basis" inputId="basis1">
        </p-radioButton>
        <label class="ms-2" for="basis1">{{membershipPlan.defaultMonthlyPrice |
            number}} {{currencyInfo.currencyCode}} {{'PAYMENT.MONTH'|translate}}</label>
    </div>
    <div class="p-field-radiobutton d-flex p-2 m-2">
        <p-radioButton name="basis" value="2" (onClick)="changeStatus(basis)" [(ngModel)]="basis" inputId="basis2">
        </p-radioButton>
        <label class="ms-2" for="basis2">{{membershipPlan.defaultYearlyPrice | number}}
            {{currencyInfo.currencyCode}} {{'PAYMENT.YEAR'|translate}} </label>
    </div>
    <label class="lbl_name" style="border-bottom:1px solid cyan; width: 100%;">{{'PAYMENT.SUBSCRIBE'|translate}}</label>
    <div class="p-field-radiobutton d-flex p-2 m-2">
        <p-radioButton name="basis" value="3" (onClick)="changeStatus(basis)" [(ngModel)]="basis" inputId="basis3">
        </p-radioButton>
        <label class="ms-2" for="basis3">{{membershipPlan.defaultMonthlyPrice |
            number}} {{currencyInfo.currencyCode}} {{'PAYMENT.PER_MONTH'|translate}}</label>
    </div>
    <div class="p-field-radiobutton d-flex p-2 m-2">
        <p-radioButton name="basis" value="4" (onClick)="changeStatus(basis)" [(ngModel)]="basis" inputId="basis4">
        </p-radioButton>
        <label class="ms-2" for="basis4">{{membershipPlan.defaultYearlyPrice | number}}
            {{currencyInfo.currencyCode}} {{'PAYMENT.PER_YEAR'|translate}} </label>
    </div>

    <div *ngIf="oneTime">
        <label class="lbl_name"
            style="border-bottom:1px solid cyan; width: 100%;">{{'PAYMENT.CARD_INFORMATION'|translate}}
            <i *ngIf="error!=null" class="pi pi-exclamation-circle float-end me-1 error_color" pTooltip="{{error}}"
                tooltipPosition="top"></i>
        </label>
        <div class="p-2" style="border-bottom: 1px solid #808080;">
            <ngx-stripe-card [options]="cardOptions" [elementsOptions]="elementsOptions"></ngx-stripe-card>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center mt-4">
            <button class="btn_in_color" style="width:60%;" type="submit" (click)="payWithStripe(basis)">
                {{'PAYMENT.PAY'|translate}}
            </button>
        </div>
    </div>

    <div *ngIf="recuringType" class="d-flex flex-column justify-content-center align-items-center mt-4">
        <button class="btn_in_color mt-3" style="width:64%;" type="submit" (click)="checkout(this.basis)">
            {{'PAYMENT.PROCEED_CHECKOUT'|translate}}
        </button>
    </div>
</div>
<div *ngIf="selectedPaymentProcessor == 'Halkbank' " class="ps-4 pe-4">
    <div class="d-flex flex-column justify-content-center align-items-center mt-4">
        <ng-container *ngIf="!postingToHalk">
            <div *ngIf="oneTime">Da Ednokratni</div>
            <div *ngIf="recuringType">Da povejkeratni</div>
            <button type="submit" class="btn_in_color mt-3" style="width:83%;"
                (click)="goToCheckoutHalk()">{{'PAYMENT.PROCEED_CHECKOUT'|translate}} prod. Halkbank</button>
        </ng-container>
        <ng-container *ngIf="postingToHalk">
            Preparing please wait...
            <!-- <form [formGroup]="HalkFormGroup" #HalkForm ngNoForm
                action="https://entegrasyon.asseco-see.com.tr/fim/est3Dgate" method="POST">
                <input type="hidden" class="form-control" formControlName="clientid" name="clientid">
                <input type="hidden" class="form-control" formControlName="storetype" name="storetype">
                <input type="hidden" class="form-control" formControlName="hash" name="hash">
                <input type="hidden" class="form-control" formControlName="trantype" name="trantype">
                <input type="hidden" class="form-control" formControlName="amount" name="amount">
                <input type="hidden" class="form-control" formControlName="currency" name="currency">
                <input type="hidden" class="form-control" formControlName="oid" name="oid">
                <input type="hidden" class="form-control" formControlName="okUrl" name="okUrl">
                <input type="hidden" class="form-control" formControlName="failUrl" name="failUrl">
                <input type="hidden" class="form-control" formControlName="lang" name="lang">
                <input type="hidden" class="form-control" formControlName="rnd" name="rnd">
                <input type="hidden" class="form-control" formControlName="encoding" name="encoding">
                <input type="hidden" class="form-control" formControlName="refreshtime" name="refreshtime">
                <input type="hidden" class="form-control" formControlName="RecurringFrequencyUnit" name="RecurringFrequencyUnit">
                <input type="hidden" class="form-control" formControlName="RecurringFrequency" name="RecurringFrequency">
            </form> -->
            <form [formGroup]="HalkFormGroup" #HalkForm ngNoForm
                action="https://epay.halkbank.mk/fim/est3Dgate" method="POST">
                <input type="hidden" class="form-control" formControlName="clientid" name="clientid">
                <input type="hidden" class="form-control" formControlName="storetype" name="storetype">
                <input type="hidden" class="form-control" formControlName="hash" name="hash">
                <input type="hidden" class="form-control" formControlName="trantype" name="trantype">
                <input type="hidden" class="form-control" formControlName="amount" name="amount">
                <input type="hidden" class="form-control" formControlName="currency" name="currency">
                <input type="hidden" class="form-control" formControlName="oid" name="oid">
                <input type="hidden" class="form-control" formControlName="okUrl" name="okUrl">
                <input type="hidden" class="form-control" formControlName="failUrl" name="failUrl">
                <input type="hidden" class="form-control" formControlName="lang" name="lang">
                <input type="hidden" class="form-control" formControlName="rnd" name="rnd">
                <input type="hidden" class="form-control" formControlName="encoding" name="encoding">
                <input type="hidden" class="form-control" formControlName="refreshtime" name="refreshtime">
                <input type="hidden" class="form-control" formControlName="instalment" name="instalment">
                <input type="hidden" class="form-control" formControlName="RecurringPaymentNumber" name="RecurringPaymentNumber">
                <input type="hidden" class="form-control" formControlName="RecurringFrequencyUnit" name="RecurringFrequencyUnit">
                <input type="hidden" class="form-control" formControlName="RecurringFrequency" name="RecurringFrequency">
            </form>
        </ng-container>
    </div>
</div>